import { createApp } from "vue";
import { createAuth0 } from "@auth0/auth0-vue";
import { createPinia } from "pinia";
import "./styles/tailwind.css";
import "./styles/scss/main.scss";
import App from "./App.vue";
import router from "@/router/index";

const app = createApp(App);
const pinia = createPinia();

app.use(
  createAuth0({
    domain: import.meta.env.VITE_AUTH0_DOMAIN,
    clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
    useRefreshTokens: true,
    useRefreshTokensFallback: true,
    cacheLocation: "localstorage",
    authorizationParams: {
      audience: import.meta.env.VITE_AUTH0_AUDIENCE,
      redirect_uri: window.location.origin,
    },
  }),
);

app.use(pinia);
app.use(router);

app.mount("#app");
